import LoginCallback from '@pages/login-callback/components/login-callback/login-callback';

const LoginCallbackPage = () => {
  return <LoginCallback />;
};

export default LoginCallbackPage;
